module.exports = __webpack_public_path__ + "img/img7.97a82eeb.png";